/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which activity level should I choose?`)
};

const es_bmr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué nivel de actividad debo elegir?`)
};

const de_bmr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welches Aktivitätsniveau sollte ich wählen?`)
};

const nl_bmr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welk activiteitsniveau moet ik kiezen?`)
};

const fr_bmr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel niveau d'activité dois-je choisir ?`)
};

const it_bmr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale livello di attività dovrei scegliere?`)
};

const pt_br2_bmr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual nível de atividade devo escolher?`)
};

const pt_bmr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual nível de atividade devo escolher?`)
};

const ja_bmr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どの活動レベルを選ぶべきですか？`)
};

const zh_bmr_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我应该选择哪个活动水平？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_faq4_q", locale)
	if (locale === "en") return en_bmr_faq4_q(inputs)
	if (locale === "es") return es_bmr_faq4_q(inputs)
	if (locale === "de") return de_bmr_faq4_q(inputs)
	if (locale === "nl") return nl_bmr_faq4_q(inputs)
	if (locale === "fr") return fr_bmr_faq4_q(inputs)
	if (locale === "it") return it_bmr_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_faq4_q(inputs)
	if (locale === "pt") return pt_bmr_faq4_q(inputs)
	if (locale === "ja") return ja_bmr_faq4_q(inputs)
	return zh_bmr_faq4_q(inputs)
};